import { inject } from "@vercel/analytics";
import { useEffect } from "react";

export const Analytics = () => {
  useEffect(() => {
    inject();
  }, []);
  return null;
};
